import { useEffect, useRef, useState } from "react";
import "./MyBookingReviewModel.css";
import { FiCamera } from "react-icons/fi";
import { HiOutlineDotsVertical } from "react-icons/hi";
import { MdDeleteForever } from "react-icons/md";
import { MdEdit } from "react-icons/md";
import { IoClose } from "react-icons/io5";


const categories = ["Food", "Ambience", "Hygiene", "Pricing", "Service"];

export default function MyBookingReviewModel({ show, onClose, }) {
    const [rating, setRating] = useState(0);

    const handleRate = (value) => {
        setRating(value);
    };


    const [ratings, setRatings] = useState({});
    const [review, setReview] = useState("");
    const [images, setImages] = useState([]);

    const handleStarClick = (category, value) => {
        setRatings({ ...ratings, [category]: value });
    };

    const handleImageUpload = (e) => {
        const files = Array.from(e.target.files);
        setImages(files);
    };

    const [open, setOpen] = useState(false);
    const menuRef = useRef();

    const toggleMenu = () => setOpen(!open);

    const handleClickOutside = (e) => {
        if (menuRef.current && !menuRef.current.contains(e.target)) {
            setOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);




    if (!show) return null;

    return (
        <div className="mbrm-modal-overlay">
            <div className="mbrm-modal-container">
                <h2>Rate and Review</h2>

                <p>
                    We'd love to hear from you! Rate your experience with the &lt; Name of
                    restaurant or club &gt; services here.
                </p>
                <div className="mbrm-modal-content-review-section">

                    <div className="mbrm-user-section">
                        <img
                            src="https://randomuser.me/api/portraits/women/44.jpg"
                            alt="User"
                            className="mbrm-user-avatar"
                        />
                        <span className="mbrm-user-name">User Name</span>
                    </div>

                    <div className="mbrm-stars-first-review">
                        {[1, 2, 3, 4, 5].map((value) => (
                            <span
                                key={value}
                                className={`mbrm-star-first ${rating >= value ? "mbrm-filled" : ""}`}
                                onClick={() => handleRate(value)}
                            >
                                ★
                            </span>
                        ))}
                    </div>

                    <div className="mbrm-experience-form">
                        <p className="mbrm-form-title">
                            To better understand your experience, please rate the key aspects listed below.
                        </p>

                        <div className="mbrm-rating-table">
                            {categories.map((category) => (
                                <div className="mbrm-rating-row" key={category}>
                                    <span className="cmbrm-ategory-label">{category}</span>
                                    <div className="mbrm-stars">
                                        {[1, 2, 3, 4, 5].map((val) => (
                                            <span
                                                key={val}
                                                className={`mbrm-star ${ratings[category] >= val ? "mbrm-filled" : ""}`}
                                                onClick={() => handleStarClick(category, val)}
                                            >
                                                ★
                                            </span>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>

                        <textarea
                            placeholder="Share Your Detailed Experience...."
                            value={review}
                            onChange={(e) => setReview(e.target.value)}
                            className="mbrm-experience-textarea"
                        />

                        <label className="mbrm-photo-upload">
                            <FiCamera className="mbrm-camera-icon" />
                            Add Photos
                            <input
                                type="file"
                                multiple
                                accept="image/*"
                                onChange={handleImageUpload}
                                hidden
                            />
                        </label>
                    </div>
                </div>

                <div className="mbrm-modal-actions">
                    <button className="mbrm-cancel-btn" onClick={onClose}>
                        Cancel
                    </button>
                    <button className="mbrm-submit-btn" >
                        Submit
                    </button>
                </div>


                {/* <>
                    <div className="mbrm-modal-review-close-icon">
                        <IoClose size={20} onClick={onClose} />
                    </div>
                    <div className="mbrm-modal-review-card">
                        <div className="mbrmrc-user-section">
                            <div className="mbrmrc-card-user-section">
                                <img
                                    src="https://randomuser.me/api/portraits/women/44.jpg"
                                    alt="User"
                                    className="mbrmrc-user-avatar"
                                />
                                <span className="mbrmrc-user-name">User Name</span>
                            </div>
                            <div className="mbrmrc-card-user-section-icon">
                                <div className="mbrmrc-three-dot-menu" ref={menuRef}>
                                    <div className="mbrmrc-dots-btn" onClick={toggleMenu}>
                                        <HiOutlineDotsVertical size={20} />
                                    </div>
                                    {open && (
                                        <div className="mbrmrc-dropdown-menu">
                                            <button ><MdEdit size={14} /> Edit</button>
                                            <button ><MdDeleteForever size={14} /> Delete</button>
                                        </div>
                                    )}
                                </div>
                            </div>

                        </div>
                        <div className="mbrmrc-content-container">
                            <div className="mbrmrc-stars">
                                {[1, 2, 3, 4, 5].map((value) => (
                                    <span
                                        key={value}
                                        className={`mbrm-star ${rating >= value ? "mbrm-filled" : ""}`}
                                        onClick={() => handleRate(value)}
                                    >
                                        ★
                                    </span>
                                ))}
                            </div>
                            <div className="mbrmrc-experience-text">
                                <p>is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing</p>
                            </div>
                            <div className="mbrmrc-user-images">
                                <img src="https://randomuser.me/api/portraits/women/44.jpg" alt="" />
                                <img src="https://randomuser.me/api/portraits/women/44.jpg" alt="" />
                                <img src="https://randomuser.me/api/portraits/women/44.jpg" alt="" />
                            </div>
                        </div>
                    </div>
                </> */}
            </div>

        </div>
    );
}
